<template>
    <DefaultLayout>
        <h1 class="h5 mt-2">
            <div>
                <span class="small text-muted">{{ i18n('Audit') }}</span>
            </div>
        </h1>


        <AuditChangeFilter :filters="filters">
            <h1 class="h5 mt-2">
                {{ i18n('Applications') }}
                <span class="small text-muted" v-if="!pagination?.total">({{ changeLogs.length }})</span>
                <span class="small text-muted" v-else>({{ pagination?.total }})</span>
            </h1>
            <template #buttons>
                <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
            </template>
        </AuditChangeFilter>
        <AuditChangeList :pagination="pagination" :changeLogs="changeLogs" :loading="loading"
            :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
            @next="nextPage" @goToPage="goToPage" />


    </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import api from "@/api.js"
import AuditChangeFilter from "@/components/auditChange/AuditChangeFilter.vue";
import AuditChangeList from "@/components/auditChange/AuditChangeList.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";

export default {
    mixins: [paginatedViewMixin,],
    components: {
        DefaultLayout,
        ExportToExcelAction,
        AuditChangeFilter,
        AuditChangeList,
    },
    data() {
        return {
            listPropertyName: 'changeLogs',
            apiResource: `changeLogs`,
            changeLogs: [],
        }
    },
    created() {
        this.filters.created_at_from = new Date().toISOString().split('T')[0];
        this.filters.is_deleted = 'all';
    },
    mounted() {
        this.$root.setPageTitle(this.i18n('Changes audit'));
        api.auth().then((user) => {
            this.$root.loggedUser = user;

            if (!user.loggedIn) {
                return; // Layout non-anonymous will handler redirect
            }

            if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
                this.$router.push({ name: 'Index', });
                return;
            }

            this.load();
        });
    },
    watch: {
        params: {
            handler() {
                this.pagination.loadPages = 1;
                this.reload();
            },
            deep: true,
        },
    },
    methods: {
        extendApiParams(params) {
            params.acl = 'changeLog';
        },
    },
};

</script>